export function wave_curve({compId,shapeHeight,animationSpeed,flipAnimation}) {
  let flipA = -4.75,
      flipB = -4.5;
  if(flipAnimation){
    flipA = -0.25;
    flipB = -0.5;
  }
  return `
<pattern class="patternSingle" id="single_${compId}" patternUnits="userSpaceOnUse" viewbox="0 0 1920 240" x="50%" y="0" height="${shapeHeight}" width="1920" preserveAspectRatio="xMidYMax meet" patternTransform="translate(0 0)">
  <path d="">
    <animate attributeType="xml" attributeName="d"
    values="M 1905.1 0 C 1530.9 0 1455.5 109.8 960 109.8 C 452.1 109.8 378.7 0 14.9 0 H 0 v 240 h 1920 V 0 H 1905.1 z;
      M1905.1,0C1530.9,0,1455.5,229.8,960,229.8C452.1,229.8,378.7,0,14.9,0H0v240h1920V0H1905.1z;
      M 1905.1 0 C 1530.9 0 1455.5 109.8 960 109.8 C 452.1 109.8 378.7 0 14.9 0 H 0 v 240 h 1920 V 0 H 1905.1 z"
    keyTimes="0;0.5;1"
    keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
    begin="${0 * animationSpeed}s" dur="${5 * animationSpeed}s" repeatCount="indefinite" />
  </path>
  <path opacity="0.66" d="">
    <animate attributeType="xml" attributeName="d"
    values="M 1905.1 0 C 1530.9 0 1455.5 69.8 960 69.8 C 452.1 69.8 378.7 0 14.9 0 H 0 v 240 h 1920 V 0 H 1905.1 z;
      M 1905.1 0 C 1530.9 0 1455.5 189.8 960 189.8 C 452.1 189.8 378.7 0 14.9 0 H 0 v 240 h 1920 V 0 H 1905.1 z;
      M 1905.1 0 C 1530.9 0 1455.5 69.8 960 69.8 C 452.1 69.8 378.7 0 14.9 0 H 0 v 240 h 1920 V 0 H 1905.1 z"
    keyTimes="0;0.5;1"
    keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
    begin="${flipA * animationSpeed}s" dur="${5 * animationSpeed}s" repeatCount="indefinite" />
  </path>
  <path opacity="0.33" d="">
    <animate attributeType="xml" attributeName="d"
    values="M 1905.1 0 C 1530.9 0 1455.5 29.8 960 29.8 C 452.1 29.8 378.7 0 14.9 0 H 0 v 240 h 1920 V 0 H 1905.1 z;
      M 1905.1 0 C 1530.9 0 1455.5 149.8 960 149.8 C 452.1 149.8 378.7 0 14.9 0 H 0 v 240 h 1920 V 0 H 1905.1 z;
      M 1905.1 0 C 1530.9 0 1455.5 29.8 960 29.8 C 452.1 29.8 378.7 0 14.9 0 H 0 v 240 h 1920 V 0 H 1905.1 z"
    keyTimes="0;0.5;1"
    keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
    begin="${flipB * animationSpeed}s" dur="${5 * animationSpeed}s" repeatCount="indefinite" />
  </path>
</pattern>
<mask id="mask_${compId}">
  <rect class="animdiv-mask animdiv-mask-top" width="100%" height="${shapeHeight}" fill="url(#pat_${compId})"></rect>
  <rect shape-rendering="crispEdges" style="transform: translate(${-((shapeHeight*8)/2+2560-2)}px,0)" class="animdiv-mask animdiv-mask-top" width="2560" y="0" x="50%" height="${shapeHeight}" fill="white"></rect>
  <rect shape-rendering="crispEdges" style="transform: translate(${(shapeHeight*8)/2-2}px,0)" class="animdiv-mask animdiv-mask-top" width="2560" y="0" x="50%" height="${shapeHeight}" fill="white"></rect>
</mask>
<mask class="flipped" id="mask_single_${compId}">
  <rect class="animdiv-mask animdiv-mask-top" x="50%" width="1920" height="${shapeHeight}" fill="url(#single_${compId})"></rect>
</mask>
`;
}